module.exports = __webpack_public_path__ + "img/mondial.8fc2213e.svg";